'use strict';

// Import Some Module
import './module/fixMenu';
import './module/accordion';
import './module/tab';
import './module/swiper';
import './module/fixFoot';
import './module/pageTop';
import './module/smoothLink';
import './module/frontAnime';
import './module/any';

// Import SassFile
import '../Sass/style.scss';
